import includes from 'ramda/src/includes';

export const isIncludeLandmark = includes("landmark");
